/* eslint-disable react/prop-types */
// TODO: refatorar quando possível
/**
 * @deprecated
 */
const TEST_ID = {
    WITH_COMING_SOON_WRAPPER: {
        COMING_SOON: 'with-coming-soon-label',
        WRAPPER: 'with-coming-soon-wrapper',
    },
    CONVERSION_SELECTOR: {
        WRAPPER: 'conversion-selector-wrapper',
    },
    SEGMENTED: {
        SEGMENTED_HEADER: {
            ADD_HOTSPOT_BUTTON: 'add_hotspot_button',
            CAMPAIGN_SELECTOR: 'segmented-header-campaign-selector',
            FIRST_SELECTOR: 'segmented-header-first-selector',
            SECOND_SELECTOR: 'segmented-header-second-selector',
            THIRD_SELECTOR: 'segmented-header-third-selector',
        },
    },
    HOT_SPOT: {
        HOT_SPOT_COMPONENT: 'hot-spot-component-test-id',
        HOT_SPOT_CONTAINER: 'hot-spot-container-test-id',
        HOT_SPOT_DELETE_ICON: 'hot-spot-delete-icon-test-id',
        HOT_SPOT_MODAL_CREATE_CATEGORY: 'hot-spot-modal-create-category-test-id',
        HOT_SPOT_MODAL_SAVE: 'hot-spot-modal-save-test-id',
        HOT_SPOT_MODAL_TOGGLE: 'hot-spot-modal-toggle-test-id',
    },
    LINKED_ANALYTICS: {
        ACCOUNT_SELECTOR: 'linked-analytics-account-selector',
        VIEW_SELECTOR: 'linked-analytics-view-selector',
        GOAL_SELECTOR: 'linked-analytics-goal-selector',
    },
    ANALYTICS: {
        ANCHOR_REDIRECT: 'google-analytics-anchor',
    },
    CREATE_CLIENT: {
        CREATE_CLIENT_WRAPPER: 'create-client-wrapper',
    },
    DELETE_CLIENT: {
        DELETE_CLIENT_WRAPPER: 'delete-client-wrapper',
    },
    COMPANY_SETTINGS: {
        MODAL: 'company-settings-modal',
        COMPANY_MANAGER_INPUT: 'company-settings-company-manager',
    },
    PAGINATION: {
        PREVIOUS_PAGE_BUTTON: 'pagination-button-previous',
        NEXT_PAGE_BUTTON: 'pagination-button-next',
    },
    LISTS: {
        PERSONS: {
            AVATAR: 'list-persons-avatar',
        },
    },
    AVATARS: {
        GROUP: 'group-of-avatars',
        SINGLE: 'single-avatars',
        NONE: 'none-avatars',
        COUNT: 'count-of-avatars',
    },
    BID_MODIFIER_MODAL: {
        DATA_TABLE: 'data-table',
        HEADER_DESCRIPTION: 'header-description',
        CHART_WRAPPER: 'chart-wrapper',
        CHART_TITLE: 'chart-title',
        EXPLANATION_TITLE: 'explanation-title',
        EXPLANATION_BODY: 'explanation-body',
        CONTENT_SUBTITLE: 'content-subtitle',
        OPTIMIZATION_TITLE: 'optimization-title',
        OPTIMIZATION_ROW: 'optimization-row',
        COST_DISTRIBUTION_ROW: 'cost-distribution-row',
        COST_DISTRIBUTION_CAPTION: 'cost-distribution-caption',
        COST_DISTRIBUTION_BAR: 'cost-distribution-bar',
        CAMPAIGN_AND_SEGMENT_ROWS: 'campaign-and-segment-rows',
    },
    FACEBOOK_ADS_MODAL: {
        ADVANCED_MODE_SWITCH: 'advanced-mode-switch',
        CAMPAIGN_DATE_START: 'campaign-date-start',
        CAMPAIGN_DATE_END: 'campaign-date-end',
        CAMPAIGN_DATE_START_TEXT: 'campaign-date-start-text',
        CAMPAIGN_DATE_END_TEXT: 'campaign-date-end-text',
        FACEBOOK_AD_ASSETS_WRAPPER: 'facebook-ad-assets-wrapper',
        FACEBOOK_AD_ASSETS_UPLOAD_INPUT: 'upload-button-input',
        FACEBOOK_AD_FORM: 'facebook-ad-form',
    },
    MANAGE_SETTINGS: 'manage-settings',
    MANAGE_SETTINGS_LOADER: 'manage-settings-loader',
    GLOBAL_SETTINGS_3: 'global-settings-3',
    FALLBACK_COMPONENTS: {
        GENERIC_COMPONENT: 'generic-fallback-component',
    },
    COMPONENTS: {
        CHECKBOX_WITH_LABEL: {
            CHECKBOX: 'checkbox',
            LABEL: 'label',
        },
        FACEBOOK_AD_PREVIEW: {
            TEXT: 'ad-text',
            DESCRIPTION: 'ad-description',
            TITLE: 'ad-title',
            URL: 'ad-url',
        },
    },
    MULTI_SELECTOR: {
        DROP_DOWN: 'multi-selector-drop-down',
        SINGLE_VALUE: 'multi-selector-single-value',
        SINGLE_VALUE_WITH_COUNTER: 'multi-selector-single-value-with-counter',
        OPTION_VALUE: 'multi-selector-test-id',
        OPTION_VALUE_VISIBLE: 'multi-selector-test-option-visible',
        OPTION_VALUE_NOT_VISIBLE: 'multi-selector-test-option-not-visible',
        SWITCH_BUTTON: 'multi-selector-switch',
        OPTION_WITH_EDIT_AND_DELETE: 'option-with-edit-and-delete-test-id',
        DROP_DOWN_BUTTON: 'drop-down-button',
        DELETE_TAG_GROUP_MODAL: 'delete-tag-group-modal',
        ADVANCED_METRIC: 'isAdvancedMetric',
    },
    ADS_IN_EXCESS: {
        WINNING_OR_LOSING_AD: 'winning-or-losing-ad',
        DELETE_ICON: 'selector-delete-icon',
    },
    CAMPAIGN_GROUP_TAGS: {
        MODAL_TITLE: 'campaign-group-tags-modal-title',
        TAG_SELECT: 'campaign-group-tags-modal-tag-select',
    },
    MANUAL_MODAL: {
        MANUAL_MODAL_TITLE: 'manual-modal-title',
    },
    SUCCESS_PAGE: {
        SUCCESS_TEST: 'success-test',
    },
    FULL_SCREEN_MODAL_SIGN_UP_TERMS: 'sign-up-terms-modal',
    FULL_SCREEN_MODAL_CLOSE_ICON: 'close-icon',
    WORKFLOW_CARDS: {
        CARD_HEADER_ALERT: 'card-header-alert',
    },
    BUDGET_CHANGE: {
        TOGGLE_MODAL_BUTTON: 'toggle-modal-button',
    },
};

export default TEST_ID;
